export const appPageStickyHeaderDataHooks = {
  APP_PAGE_STICKY: 'app-page-sticky',
  APP_STICKY_HEADER_BACK_BUTTON: 'app-sticky-header-back-button',
  APP_STICKY_HEADER_INFO_BADGE: 'app-sticky-header-info-badge',
};
